import { render, staticRenderFns } from "./community_h5.vue?vue&type=template&id=20c9f632&scoped=true"
import script from "./community_h5.vue?vue&type=script&lang=js"
export * from "./community_h5.vue?vue&type=script&lang=js"
import style0 from "./community_h5.vue?vue&type=style&index=0&id=20c9f632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9f632",
  null
  
)

export default component.exports